import { Injectable } from '@angular/core';
import { Actions, Select, Store } from '@ngxs/store';
import { AssignCertificatesToModuleUsers, UnassignCertificatesFromModuleUsers } from 'app/library/module-certificate/actions';
import { IManageModuleUserCertificatesActionPayload } from 'app/library/module-certificate/interfaces/module-certificate-action.action-payload.interface';
import { ModuleCertificateExtended } from 'app/library/module-certificate/models/module-certificate.extended.model';
import { ModuleService } from 'app/library/module/services/module.service';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { Observable } from 'rxjs';
import { FetchModuleCertificates, FetchModuleCertificatesFailure, FetchModuleCertificatesSuccess } from '../actions';
import { ModuleCertificatesState } from '../models/module-certificates.state';

@Injectable()
export class ModuleCertificatesService {
    @Select(ModuleCertificatesState.getEntitiesWithCertificate)
    moduleCertificates$: Observable<ModuleCertificateExtended[]>;

    constructor(private _store: Store, private _actionHelper: NgxsActionHelper, private _action$: Actions, private _moduleService: ModuleService) {}

    getModuleCertificates(): ModuleCertificateExtended[] {
        return this._store.selectSnapshot(ModuleCertificatesState.getEntitiesWithCertificate);
    }

    async fetchModuleCertificates(moduleId?: string): Promise<boolean> {
        const currentModuleId = moduleId || this._moduleService.getCurrentModule().id;
        this._store.dispatch(new FetchModuleCertificates({ moduleId: currentModuleId }));

        return await this._actionHelper.race(FetchModuleCertificatesSuccess, FetchModuleCertificatesFailure).toPromise();
    }

    async assignCertificatesToModuleUsers(payload: IManageModuleUserCertificatesActionPayload): Promise<void> {
        this._store.dispatch(new AssignCertificatesToModuleUsers(payload));
        // TODO: add race condition, it did not work for some reason...
    }

    async unassignCertificatesToModuleUsers(payload: IManageModuleUserCertificatesActionPayload): Promise<void> {
        this._store.dispatch(new UnassignCertificatesFromModuleUsers(payload));
    }
}
